import './review-block.scss';
import Swiper from 'swiper/swiper-bundle';

export default () => {
	new Swiper( '.js-review-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		pagination: {
			el: '.review__dots ',
			clickable: true,
		},
		navigation: {
			prevEl: '.review-block-prev',
			nextEl: '.review-block-next',
		},

		breakpoints: {
			992: {
				slidesPerView: 3,
				spaceBetween: 32,
			},

		},

	} );
};
